module.exports = __webpack_public_path__ + "img/step-2-time.037f9b93.svg";